import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboMetaAcaoComponent } from './combo-meta-acao.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboMetaAcaoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboMetaAcaoComponent]
})
export class ComboMetaAcaoModule { }
